module.exports = __webpack_public_path__ + "img/symbol_12.442e4696.png";